import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type {
	CostCenterOption,
	FirstTurnedRollRow,
} from "../models/FirstTurnedRolls";

export interface GetFirstTurnedRollsParams {
	start: string;
	end: string;
	costCenterId: number;
	signal?: AbortSignal;
}

export const getFirstTurnedRollsData = async ({
	start,
	end,
	costCenterId,
	signal,
}: GetFirstTurnedRollsParams): Promise<FirstTurnedRollRow[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "start", value: start },
		{ name: "end", value: end },
		{ name: "costCenterId", value: costCenterId },
		{ name: "timeZoneCode", value: null },
		{ name: "fromRow", value: 0 },
		{ name: "toRow", value: null },
		{ name: "rowsToFetch", value: 100000 },
		{ name: "sortType", value: null },
	];

	const spName = "[ROLLS].[GetFirstTurnedRollsDataWeb]";
	const resp = await apiService.callV2(spName, parameters, signal);

	if (!resp.ok) {
		throw new Error(resp.message || "Error fetching first turned rolls");
	}
	return get(resp, "data.tables[0].rows", []) as FirstTurnedRollRow[];
};

export const getCostCenters = async (
	signal?: AbortSignal,
): Promise<CostCenterOption[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "Id", value: null },
		{ name: "OnlyActives", value: true },
	];

	const resp = await apiService.callV2(
		"[MILL].[GetCostCenters]",
		parameters,
		signal,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error fetching cost centers");
	}
	return get(resp, "data.tables[0].rows", []) as CostCenterOption[];
};
